module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('h1', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('table', {
    staticClass: "a-table a-table--modal",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.selectColumn(index)
        },
        "mouseover": function($event) {
          return _vm.hoverColumn(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(header) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row, key, index) {
    return _c('tr', {
      class: [_vm.highlightColumn(key, index), _vm.lightHighlightColumn(key, index)],
      on: {
        "click": function($event) {
          return _vm.selectRow(key)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "mouseover": function($event) {
          return _vm.hoverRow(key)
        }
      }
    }, [_vm._v("\n                " + _vm._s(key) + "\n            ")]), _vm._v(" "), _vm._l((row), function(column, index) {
      return _c('td', {
        class: [_vm.highlightColumn(key, index), _vm.lightHighlightColumn(key, index)]
      }, [_vm._v("\n                " + _vm._s(column) + "\n            ")])
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v("\n                " + _vm._s(key) + "\n            ")])], 2)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-da86f1f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources-and-tools/OgdenTables/OgdenTableViewer.vue
// module id = 1818
// module chunks = 0